import mwrHttp from '@/utils/activityHttp'
import store from '@/store'
import ta from 'thinkingdata-browser'
import { getActLog } from '@/plugins/actlog'

// 开发走本地代理前缀；其他环境用 VUE_APP_ACT_URL
const actHost =
  process.env.VUE_APP_ENV === 'dev'
    ? ''
    : String(process.env.VUE_APP_ACT_URL || '').replace(/\/$/, '')
const basePath = `${actHost}/minifire-ann/api/v1/ann`
const basePathCommon = `${actHost}/minifire-ann/api/v1`
const basePath2 = `${actHost}/minifire_account_server_os/api/v1`

export default {
  // ---------- 账号服（与世界杯一致，换票不经活动服） ----------
  gameTokenLogin: async (params) => {
    try {
      const res = await mwrHttp.post(`${basePath2}/game/gameTokenLogin`, params)
      store.commit('SET_ACT_USER_INFO', {
        token: res.authorization,
        expireAt: res.expireAt,
        ...res.roleInfo,
      })
      // 端内静默登录。下一行即整页重载，此处同步上报，存在少量丢失风险
      const uid = store.state.actUserInfo.uid || ''
      if (uid) ta.login(uid)
      getActLog()?.track('act_anni_login', { v1: 1 })
    } catch (error) {
      console.error(error)
    }
    location.href = location.origin + location.pathname
  },

  loginByMailCode: async (params) => {
    const res = await mwrHttp.post(`${basePath2}/game/gameMailLogin`, params)
    store.commit('SET_ACT_USER_INFO', {
      token: res.authorization,
      expireAt: res.expireAt,
      ...res.roleInfo,
    })
    return res
  },

  sendMailCode: (params) => {
    return mwrHttp.post(`${basePath2}/game/sendGameMailVerifyCode`, params)
  },

  // ---------- 公共 / 活动 ----------
  getCommonConfig: (params) => {
    return mwrHttp.post(`${basePathCommon}/get-common-config`, params)
  },

  getActivityInfo: (params) => {
    return mwrHttp.post(`${basePath}/activity-info`, params)
  },

  getGlobalProgress: (params) => {
    return mwrHttp.post(`${basePath}/global-progress`, params)
  },

  receiveFirstLoginReward: (params) => {
    return mwrHttp.post(`${basePath}/receive-first-login-reward`, params)
  },

  getTaskList: (params) => {
    return mwrHttp.post(`${basePath}/task-list`, params)
  },

  receiveTaskReward: (params) => {
    return mwrHttp.post(`${basePath}/receive-task-reward`, params)
  },

  share: (params) => {
    return mwrHttp.post(`${basePath}/share`, params)
  },

  ignite: (params) => {
    return mwrHttp.post(`${basePath}/ignite`, params)
  },

  receiveGlobalReward: (params) => {
    return mwrHttp.post(`${basePath}/receive-global-reward`, params)
  },

  getMilestoneList: (params) => {
    return mwrHttp.post(`${basePath}/milestone-list`, params)
  },

  receiveMilestone: (params) => {
    return mwrHttp.post(`${basePath}/receive-milestone`, params)
  },

  getRecallInfo: (params) => {
    return mwrHttp.post(`${basePath}/recall-info`, params)
  },

  receiveRecallReward: (params) => {
    return mwrHttp.post(`${basePath}/receive-recall-reward`, params)
  },

  getRewardRecord: (params = {}) => {
    return mwrHttp.post(`${basePath}/reward-record`, params)
  },
}
